import { CSSProperties } from "react";

export const blurFix: CSSProperties = {
    // MacOS Chrome
    imageRendering: "-webkit-optimize-contrast",
    // Windows
    transform: "translateZ(0)",
};
